import * as React from 'react';
import { withDataFetch } from '../hoc/withDataFetch';

const Doughnut = React.lazy(() =>
  import('react-chartjs-2').then(module => ({ default: module.Doughnut }))
);

export default withDataFetch(Doughnut);
